import Image from 'next/image';
import Dropdown from '../Redactie/Dropdown/Dropdown';
import CHARACTERS from '@/resources/Characters';
import { mdiPencil } from '@mdi/js';
import DropdownButton from '../Redactie/Dropdown/DropdownButton';
import Icon from '@mdi/react';

const BlockEditorCharacterPicker = ({
    characterName,
    setCharacterName,
}: {
    characterName: string;
    setCharacterName: (id: string) => void;
}) => {
    const characterId = CHARACTERS[characterName]
        ? characterName
        : CHARACTERS[0].name;

    return (
        <Dropdown
            customAlignmentClassName="-top-[5.25rem] left-0"
            triggerElement={
                <button className="relative w-16 h-16 m-1 rounded-full hover:opacity-90 active:opacity-75 hover:scale-105 active:scale-95 transition-all">
                    <Image
                        className="rounded-full shadow-md"
                        src={require(
                            `@/resources/CharacterAvatars/${characterId}.jpg`,
                        )}
                        width={128}
                        height={128}
                        alt={`Profielfoto van ${CHARACTERS[characterId].displayName}`}
                        aria-hidden="true"
                    />
                    <div className="absolute top-11 left-11 bg-white rounded-full p-1 shadow-md">
                        <Icon path={mdiPencil} size={0.6} />
                    </div>
                </button>
            }
            contentContainerClassName="w-52"
            className="shrink-0"
        >
            {Object.values(CHARACTERS).map(({ name, displayName, color }) => (
                <DropdownButton
                    key={displayName}
                    onClick={() => {
                        setCharacterName(name);
                    }}
                >
                    <span
                        className={`relative flex gap-3 w-full items-center text-${color} font-bold`}
                    >
                        <div
                            className={`absolute -left-2 w-2 h-2 bg-slate-500 rounded-full ${
                                name === characterId
                                    ? 'bg-opacity-100'
                                    : 'bg-opacity-0'
                            }`}
                        />
                        <Image
                            className="shrink-0 rounded-full shadow-md h-6 w-6 ms-2"
                            src={require(
                                `@/resources/CharacterAvatars/${name}.jpg`,
                            )}
                            width={32}
                            height={32}
                            alt={`Profielfoto van ${displayName}`}
                            aria-hidden="true"
                        />
                        <span className="line-clamp-1">{displayName}</span>
                    </span>
                </DropdownButton>
            ))}
        </Dropdown>
    );
};

export default BlockEditorCharacterPicker;
